import PropTypes from 'prop-types';
import overlay from '@activebrands/core-web/libs/overlay';
import { styled } from '@activebrands/core-web/libs/styletron';
import { getFocusRingStyles } from '@activebrands/core-web/utils/style-functions/get-focus-styles';

const Button = styled('button', ({ $isOpen }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '10px',
    cursor: 'pointer',

    ...($isOpen
        ? {
              '::after': {
                  content: '""',
                  position: 'absolute',
                  left: '50%',
                  bottom: '-1px',
                  width: '24px',
                  height: '1px',
                  transform: 'translateX(-50%)',
              },
          }
        : {}),
    ...getFocusRingStyles(),
}));

const OverlayToggler = ({
    children,
    isOpen = false,
    overlayId = '',
    overlayProps,
    resetNavigation,
    $style,
    ...rest
}) => {
    const handleOnClick = () => {
        if (resetNavigation) {
            resetNavigation();
        }

        if (isOpen) {
            overlay.close(overlayId);
        } else {
            overlay.closeAll();
            overlay.open(overlayId, overlayProps);
        }
    };

    return (
        <Button
            $isOpen={isOpen}
            $style={$style}
            aria-controls={`overlay-${overlayId}`}
            aria-expanded={isOpen}
            aria-haspopup="dialog"
            type="button"
            onClick={handleOnClick}
            {...rest}
        >
            {typeof children === 'function' ? children(isOpen) : children}
        </Button>
    );
};

OverlayToggler.propTypes = {
    $style: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    isOpen: PropTypes.bool,
    overlayId: PropTypes.string.isRequired,
    overlayProps: PropTypes.object,
    resetNavigation: PropTypes.func,
};

export default OverlayToggler;
